import React, {
    ReactNode,
    createContext,
    useContext,
    useState,
  } from "react";
  
  
  interface urlBodyContextProps {
    urlBody: string;
    setUrlBody: Function ;
  }
  
  interface urlBodyProviderProps {
    children: ReactNode;
  }
  
  const UrlBodyContext = createContext<urlBodyContextProps | undefined>(undefined);
  
  
  const UrlBodyProvider: React.FC<urlBodyProviderProps> = ({ children }) => {
    const [urlBody, setUrlBody] = useState('');
  
    return (
      <UrlBodyContext.Provider value={{ setUrlBody ,urlBody }}>{children}</UrlBodyContext.Provider>
    );
  };
  
  export const useUrlBodyContext = () => {
    const context = useContext(UrlBodyContext);
    if (!context) {
      throw new Error("useUrlBodyContext must be used within a urlBodyProvider");
    }
    return context;
  };
  
  export default UrlBodyProvider;
  